"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dayjs = _interopRequireDefault(require("../utils/dayjs"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _clock = _interopRequireDefault(require("@spothero/icons/clock"));
var _time = _interopRequireDefault(require("@spothero/utils/time"));
var _Select = _interopRequireDefault(require("../Select/Select"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class TimePicker extends _react.Component {
  static defaultProps = {
    useIcon: true,
    step: 30,
    iconPosition: 'right',
    displayFormat: 'hh:mm A'
  };
  constructor(props) {
    super(props);
    const times = this.calculateTimes();
    this.state = {
      selectedTime: props.selectedTime,
      times
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      onChange,
      disableBefore
    } = this.props;
    const {
      selectedTime
    } = this.state;
    if (selectedTime !== prevState.selectedTime && onChange) {
      onChange(selectedTime);
    }

    // Update the state when disableBefore is set and the selectedTime is not in the list of times
    if (disableBefore && selectedTime) {
      const times = this.calculateTimes();
      const newSelectedTime = times.find(({
        value
      }) => value === selectedTime) ? selectedTime : times[0].value;

      // Only update the state if the selectedTime has changed
      if (selectedTime !== newSelectedTime) {
        this.setState(state => ({
          ...state,
          selectedTime: newSelectedTime,
          times
        }));
        if (onChange) {
          onChange(newSelectedTime);
        }
      }
    }
  }
  _onSelectChange = ({
    value
  }) => {
    this.setState({
      selectedTime: value
    });
  };

  /**
   * Getter for the select DOM element.
   *
   * @public
   * @returns {Element} - The select element.
   */
  get node() {
    return this._select.node;
  }
  calculateTimes() {
    const {
      step,
      disableBefore,
      disableAfter,
      displayFormat
    } = this.props;
    const dayStart = (0, _dayjs.default)().startOf('day');
    const timesParams = {
      step
    };
    if (disableBefore) {
      timesParams.ignoreBefore = (0, _dayjs.default)(disableBefore, 'hh:mm A').diff(dayStart, 'minute');
    }
    if (disableAfter) {
      timesParams.ignoreAfter = (0, _dayjs.default)(disableAfter, 'hh:mm A').diff(dayStart, 'minute');
    }
    return _time.default.getTimes(timesParams).map(({
      formatted
    }) => {
      return {
        value: formatted,
        label: displayFormat ? _time.default.getAsDayjs(formatted).format(displayFormat) : formatted
      };
    });
  }
  render() {
    const {
      className,
      label,
      placeholder,
      useIcon,
      iconPosition,
      name,
      disabled,
      ...attrs
    } = this.props;
    const spreadProps = (0, _omit.default)(attrs, ['onChange', 'step', 'displayFormat', 'disableBefore', 'disableAfter', 'selectedTime']);
    const {
      selectedTime,
      times
    } = this.state;
    const classes = (0, _classnames.default)('TimePicker', {
      'TimePicker-with-icon': useIcon
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, label, /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({
      ref: node => {
        this._select = node;
      },
      name: name,
      defaultValue: selectedTime,
      onChange: this._onSelectChange,
      items: times,
      disabled: disabled,
      icon: useIcon ? /*#__PURE__*/_react.default.createElement(_clock.default, {
        className: "Icon-clock"
      }) : null,
      iconPosition: iconPosition,
      placeholder: placeholder,
      "aria-label": placeholder
    }, spreadProps)));
  }
}
exports.default = TimePicker;